import { Injectable, Injector } from '@angular/core';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root' // Esto hace que el service sea singleton
})
export class TenantService {
    private _tenantId: number | null = null;
    private _tenancyName: string | null = null;
    private authenticationService: AuthenticationService;

    constructor(private injector: Injector) {
        this.authenticationService = injector.get(AuthenticationService);
        this.initializeTenantData();
    }

    /**
     * Inicializa los datos del tenant desde el usuario actual
     */
    private initializeTenantData(): void {
        try {
            const currentUser = this.authenticationService?.currentUserValue;
            this._tenantId = currentUser?.tenantId || null;
            this._tenancyName = currentUser?.tenancyName || null;
        } catch (error) {
            console.warn('No se pudo obtener el tenant ID:', error);
            this._tenantId = null;
            this._tenancyName = null;
        }
    }

    /**
     * Obtiene el ID del tenant actual
     */
    get tenantId(): number | null {
        if (this._tenantId === null) {
            this.initializeTenantData(); // Re-intentar obtener el tenant ID
        }
        return this._tenantId;
    }

    /**
     * Obtiene el nombre del tenant actual
     */
    get tenantName(): string | null {
        if (this._tenancyName === null) {
            this.initializeTenantData(); // Re-intentar obtener el tenant name
        }
        return this._tenancyName;
    }

    /**
     * Verifica si el tenant actual es específico (util para lógica condicional)
     */
    isTenant(targetTenantId: number): boolean {
        return this.tenantId === targetTenantId;
    }

    /**
     * Verifica si el tenant actual está en una lista de tenants
     */
    isTenantInList(tenantIds: number[]): boolean {
        return this.tenantId !== null && tenantIds.includes(this.tenantId);
    }

    /**
     * Verifica si es tenant de México (6 u 8 según el código del menú)
     */
    isMexicoTenant(): boolean {
        return this.isTenantInList([6, 8]);
    }

    /**
     * Verifica si es tenant de Ford (cualquiera que no sea 6 u 8)
     */
    isFordTenant(): boolean {
        return this.tenantId !== null && !this.isMexicoTenant();
    }

    /**
     * Fuerza la actualización de los datos del tenant
     */
    refreshTenantData(): void {
        this.initializeTenantData();
    }

    /**
     * Obtiene información completa del tenant
     */
    getTenantInfo(): { id: number | null, name: string | null } {
        return {
            id: this.tenantId,
            name: this.tenantName
        };
    }
}